import axios from 'axios';

import config from '../config';

const savedEndpoint = window.sessionStorage.getItem('clientEndpoint');

const clientInstance = axios.create({
  baseURL: savedEndpoint || config.baseURL,
});

export default clientInstance;
